/*
 * Preezie AI Shopping Assistant -> GA4 bridge (no GTM needed)
 * Sends aishoppingassistant.* dataLayer events straight to GA4 via gtag,
 * using the same event and parameter names as the Preezie GTM preset.
 */
(function () {
  var MEASUREMENT_ID = 'G-GSJB7DVJBT'; // merchant's GA4 ID
  var DEBUG = false;                   // true = log each event to console

  if (window.__przGa4Bridge) return;   // guard against double loading
  window.__przGa4Bridge = true;

  // Same param names as the GTM preset (field in payload -> GA4 param)
  var PARAM_MAP = {
    'abTestingVersion': 'aishoppingassistant_ab_testing_version',
    'hotLink.position': 'aishoppingassistant_hotLink_position',
    'hotLink.text': 'aishoppingassistant_hotLink_text',
    'intent': 'aishoppingassistant_intent',
    'isSuggestedText': 'aishoppingassistant_is_suggested_text',
    'message': 'aishoppingassistant_message',
    'numberOfProducts': 'aishoppingassistant_numberOfProducts',
    'page': 'aishoppingassistant_page',
    'popupClickAction': 'aishoppingassistant_popup_click_action',
    'popupDisplayMessage': 'aishoppingassistant_popup_display_message',
    'popupId': 'aishoppingassistant_popup_id',
    'popupPromptText': 'aishoppingassistant_popup_prompt_text',
    'popupTriggerType': 'aishoppingassistant_popup_trigger_type',
    'productId': 'aishoppingassistant_product_id',
    'productName': 'aishoppingassistant_product_name',
    'productPosition': 'aishoppingassistant_product_position',
    'productPrice': 'aishoppingassistant_product_price',
    'triggerBarMainButton.target': 'aishoppingassistant_triggerBarMainButton_target',
    'triggerBarMainButton.text': 'aishoppingassistant_triggerBarMainButton_text',
    'triggerType': 'aishoppingassistant_trigger_type'
  };

  window.dataLayer = window.dataLayer || [];

  // Load gtag only if the theme doesn't already have it
  if (typeof window.gtag !== 'function') {
    window.gtag = function () { window.dataLayer.push(arguments); };
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + MEASUREMENT_ID;
    document.head.appendChild(s);
    window.gtag('js', new Date());
    window.gtag('config', MEASUREMENT_ID, { send_page_view: false });
  }

  function get(obj, path) {
    return path.split('.').reduce(function (o, k) {
      return o == null ? undefined : o[k];
    }, obj);
  }

  function forward(entry) {
    if (!entry || typeof entry.event !== 'string') return;
    if (entry.event.indexOf('aishoppingassistant') !== 0) return;

    var data = entry.aishoppingassistant || {};
    var params = { send_to: MEASUREMENT_ID };

    Object.keys(PARAM_MAP).forEach(function (path) {
      var v = get(data, path);
      if (v !== undefined && v !== null && v !== '') params[PARAM_MAP[path]] = v;
    });

    if (data.visitorId || data.sessionId) {
      window.gtag('set', 'user_properties', {
        aishoppingassistant_user: (data.visitorId || '') + '_' + (data.sessionId || '')
      });
    }

    var name = entry.event.replace(/\./g, '_');
    window.gtag('event', name, params);
    if (DEBUG) console.log('[prz-ga4]', name, params);
  }

  // Catch events pushed before this script loaded
  window.dataLayer.slice().forEach(forward);

  // Catch everything pushed from now on
  var originalPush = window.dataLayer.push;
  window.dataLayer.push = function () {
    for (var i = 0; i < arguments.length; i++) forward(arguments[i]);
    return originalPush.apply(window.dataLayer, arguments);
  };
})();
